import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RightTimeToBuy from "@/pages/tools/RightTimeToBuy";

export const Route = createFileRoute("/tools/right-time-to-buy")({
  head: () => seoHead("/tools/right-time-to-buy"),
  component: RightTimeToBuy,
});
